import React, { Fragment, useState } from 'react'

// import { Link, useLocation } from 'react-router-dom'
import styled from 'styled-components'

// import { useWindowSize, useEventListener } from '../../../_helpers'
import {
    // Header,
    // ImageCard,
    // ArticleTextWrap,
    // Block,
    // Grid,
    // devices,
    // SecondaryButton,
    colors, devices,
} from '../../Common'


export const SimpleBlock = ({ pageBlock }) => (
    <TextBlock>
        <div dangerouslySetInnerHTML={{ __html: pageBlock.content }} />
    </TextBlock>
)

const TextBlock = styled.div`
    font-weight: 900;
    font-style: normal;
    /* letter-spacing: 1.5px; */
    font-size: 48px;
    background: ${colors.red};
    color: ${colors.white};
    width: 100%;
    height: 95vh;

    display: flex;
    justify-content: center;
    align-items: center;

    div {
        width: 70%;
        p {
            margin: 0;
        }
    }

    @media ${devices.small} {
        font-size: 28px;

        div {
            width: 90%;
        }
    }
`
